module.exports = __webpack_public_path__ + "static/first-7e382db42ee0632680fef984c4045bbd.jpg";